import React, { useMemo } from 'react';
import styles from './GameInfoTabContent.module.scss';
import { T } from '@colonist/ui';
const SettingItem = ({ label, value })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.settingItem
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: label
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.value
    }, /*#__PURE__*/ React.createElement(T, {
        id: value
    })));
export const GameInfoTabContent = ({ gameInfo })=>{
    const settingGroups = useMemo(()=>{
        const generalSettings = [
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.vpToWin.title'
                },
                value: gameInfo.victoryPointsToWin
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.cardDiscardLimit.title'
                },
                value: gameInfo.cardDiscardLimit
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.turnTimer.title'
                },
                value: gameInfo.gameSpeed
            }
        ];
        const gameSetupSettings = [
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.gameMode.title'
                },
                value: gameInfo.modeSetting
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.scenario.title'
                },
                value: gameInfo.scenarioSetting
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.map.title'
                },
                value: gameInfo.mapSetting
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.extension.title'
                },
                value: gameInfo.extensionSetting
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.dice.title'
                },
                value: gameInfo.diceSetting
            }
        ];
        const rulesSettings = [
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.karma.title'
                },
                value: gameInfo.karmaActive
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.bankCards.title'
                },
                value: gameInfo.hideBankCards
            },
            {
                label: {
                    key: 'strings:game.settings.gameInfoTab.friendlyRobber.title'
                },
                value: gameInfo.friendlyRobber
            }
        ];
        return [
            generalSettings,
            gameSetupSettings,
            rulesSettings
        ];
    }, [
        gameInfo
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.gameInfoTabContentContainer
    }, settingGroups.map((group, groupIndex)=>/*#__PURE__*/ React.createElement("div", {
            key: groupIndex,
            className: styles.settingGroup
        }, group.map((row)=>/*#__PURE__*/ React.createElement(SettingItem, {
                key: row.label.key,
                label: row.label,
                value: row.value
            })))));
};
